import React from 'react';
import { Box, Chip } from '@mui/material';
import type { MoveQualityCounts } from 'endchess-contracts';
import MoveQualityCountBubbles from './MoveQualityCountBubbles';

type GameAnalysisStatus = 'pending' | 'ready' | 'none' | 'scheduled';

const formatAnalysisStatusLabel = (
  status: GameAnalysisStatus | undefined,
): string | null => {
  if (status === 'pending') {
    return 'Analyzing…';
  }
  if (status === 'none') {
    return 'Not analyzed';
  }
  if (status === 'ready') {
    return 'Analyzed';
  }
  if (status === 'scheduled') {
    return 'Will analyze tomorrow';
  }
  return null;
};

type GameAnalysisStatusBlockProps = {
  analysisStatus?: GameAnalysisStatus;
  moveQualityCounts?: MoveQualityCounts;
  sx?: { ml?: number };
};

const GameAnalysisStatusBlock = ({
  analysisStatus,
  moveQualityCounts,
  sx,
}: GameAnalysisStatusBlockProps) => {
  const label = formatAnalysisStatusLabel(analysisStatus);
  if (!label) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        flexWrap: 'wrap',
        verticalAlign: 'middle',
        ...sx,
      }}
    >
      {analysisStatus === 'ready' && moveQualityCounts ? (
        <MoveQualityCountBubbles counts={moveQualityCounts} />
      ) : null}
      <Chip size="small" label={label} />
    </Box>
  );
};

export default GameAnalysisStatusBlock;
